//import api from '../api'
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    yardQc: [],
    searchRequest: {},
  },
  mutations: {
    updateYardQc(state, yardQc) {
      state.yardQc = yardQc;
    },
    updateSearchYardQcRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadYardQc({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

      if (requestToSend.endOutletFrom && !requestToSend.endOutletTo) {
        requestToSend.endOutletTo = requestToSend.endOutletFrom;
      }
      if (requestToSend.storeIdFrom && !requestToSend.storeIdTo) {
        requestToSend.storeIdTo = requestToSend.storeIdFrom;
      }
      //const result = await api.post('/api/w/yardQc', requestToSend);
      const result = await newAPIPost('/api/w/yardQc', requestToSend);
      commit('updateSearchYardQcRequest', fallbackRequest);
      return commit('updateYardQc', result);
    },
    updateLoadQcStatus(store, request) {
      //return api.post('/api/w/loads/updateQcStatus', request);
      return newAPIPost('/api/w/loads/updateQcStatus', request);
    },
    updateYardQc(store, request) {
      //return api.post('/api/w/yardQc/update', request);
      return newAPIPost('/api/w/yardQc/update', request);
    },
  },
  getters: {
    getYardQc: state => state.yardQc,
  },
}
